import $ from 'jquery';

$(function() {
  var villagebrewery = {'ajax_url':'\/wp\/wp-admin\/admin-ajax.php'};

  $('#showFilterToggle').on('click', function(e) {
    e.preventDefault();
    
    if( $( '#filters' ).hasClass( 'hidden' ) ) {
      $( '#filters' ).removeClass( 'hidden' );
      $( '#showFilterToggle' ).find( '.filter-span' ).text( "Hide Filters" )
      $( '#showFilterToggle' ).addClass( 'open' )
    } else {
      $( '#filters' ).addClass( 'hidden' );
      $( '#showFilterToggle' ).find( '.filter-span' ).text( "More Filters" )
      $( '#showFilterToggle' ).removeClass( 'open' )
    }

    if( $( '.top-filters' ).hasClass( 'block' ) ) {
      return
    } else {
      if( $( '.top-filters' ).hasClass( 'hidden' ) ) {
        $( '.top-filters' ).removeClass( 'hidden' )
      } else {
        $( '.top-filters' ).addClass( 'hidden' )
      }
    }
  });

  $('#filter-products input').on('change', function(e) {
    e.preventDefault();

    let product_container = $('#product-list');
    product_container.hide().empty();

    let data = $('#filter-products').serialize();

    // eslint-disable-next-line no-undef
    $.get( villagebrewery.ajax_url, data, $.proxy( function( html ) {
      if ( html === '' ) {
        console.log('do nothing');
      } else {
        product_container.show().append(html);
      }

    }, this));
  })

  $('#filter-news input').on('change', function(e) {
    e.preventDefault();

    let news_container = $('#news-list');
    news_container.hide().empty();

    let data = $('#filter-news').serialize();

    // eslint-disable-next-line no-undef
    $.get(villagebrewery.ajax_url, data, $.proxy(function(html) {
      if (html === '') {
        console.log('do nothing');
      } else {
        news_container.show().append(html);
      }

    }, this));
  })

});
